import appStore from "../Stores/AppStore";

export const serverOrigin = "https://test.kotobot.app/api";

export class ServerRequestError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
    Object.setPrototypeOf(this, ServerRequestError.prototype);
    this.name = "ServerRequestError";
  }
}

export class ServerClient {
  static async sendRequestAsync(requestParams: {
    url: string;
    method: string;
    body?: BodyInit;
    headers?: HeadersInit;
    credentials?: RequestCredentials;
  }): Promise<unknown> {
    appStore.updateLastRequestTime();
    const headers = new Headers(requestParams.headers);
    if (!headers.has("Accept-Language") && navigator.language) {
      headers.set("Accept-Language", navigator.language);
    }
    const response = await fetch(requestParams.url, {
      method: requestParams.method,
      body: requestParams.body,
      headers,
      credentials: requestParams.credentials,
    });

    let answer: any & { status: number; message: string } =
      await response.json().catch((error) => {
        if (response.status >= 400) throw new ServerRequestError(response.status, response.statusText);
        throw error;
      });

    if (response.status >= 400 || answer.status !== 200) {
      throw new ServerRequestError(response.status >= 400 ? response.status : answer.status, answer.message);
    }

    return answer;
  }
}
